var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-icon",class:_vm.iconClass,style:([
        _vm.width || _vm.size ? { width: _vm.cssWidth } : {},
        _vm.height || _vm.size ? { height: _vm.cssHeight } : {},
        _vm.color ? { color: _vm.color } : {}
    ])},[_c(`Icon${_vm.icon}`,_vm._b({tag:"component"},'component',_vm.iconBindings,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }